/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import clsx from 'clsx'
import { addDays, format } from 'date-fns'
import ja from 'date-fns/locale/ja'
import React from 'react'
import { FacilityAvailableStatusCode } from '../../entites/FacilityInfo'
import { color } from '../../utils/Style'
import { CircleStatusIcon } from '../CircleStatusIcon'
import { CardSection, Heading } from './CardSection'

export type AvailabilityProps = {
  todayStatusCode: FacilityAvailableStatusCode
  tomorrowStatusCode: FacilityAvailableStatusCode
  todayStatusText: string
  tomorrowStatusText: string
}

export const Availability = ({
  todayStatusCode,
  tomorrowStatusCode,
  todayStatusText,
  tomorrowStatusText,
}: AvailabilityProps) => {
  const today = new Date()
  const tomorrow = addDays(today, 1)
  const todayDate = format(today, 'MM/dd', {
    locale: ja,
  })
  const todayWeekDay = format(today, 'eee', {
    locale: ja,
  })
  const tomorrowDate = format(tomorrow, 'MM/dd', {
    locale: ja,
  })
  const tomorrowWeekDay = format(tomorrow, 'eee', {
    locale: ja,
  })

  return (
    <CardSection css={availabilityStyle}>
      <Heading>現在の空き状況</Heading>
      <div>
        <div className="today">
          <span className="date_label">今日</span>
          <span className="date_date">{todayDate}</span>
          <span className="date_day">（{todayWeekDay}）</span>
          <CircleStatusIcon statusCode={todayStatusCode} size="semismall" />
          <span className={clsx('status', todayStatusCode)}>
            {todayStatusText}
          </span>
        </div>
        <div className="tommorow">
          <span className="date_label">明日</span>
          <span className="date_date">{tomorrowDate}</span>
          <span className="date_day">（{tomorrowWeekDay}）</span>
          <CircleStatusIcon statusCode={tomorrowStatusCode} size="semismall" />
          <span className={clsx('status', tomorrowStatusCode)}>
            {tomorrowStatusText}
          </span>
        </div>
      </div>
    </CardSection>
  )
}

const availabilityStyle = css`
  .today {
    display: flex;
  }
  .tommorow {
    display: flex;
    margin-top: 15px;
  }

  .date_label {
    font-size: 14px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .date_date {
    padding-left: 5px;
    font-weight: bold;
    font-size: 18px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .date_day {
    padding-right: 3px;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .status {
    padding-left: 5px;
    font-weight: bold;
    font-size: 16px;
    line-height: 125%;
    &.vacancies {
      color: ${color.colorVacancies};
    }
    &.vacancies_little {
      color: ${color.colorVacanciesLittle};
    }
    &.congestion {
      color: ${color.colorFull};
    }
    &.full {
      color: ${color.colorFull};
    }
  }
`
